import React from 'react';
import ReactDOM from 'react-dom';
import createSagaMiddleware from "redux-saga";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
// import reportWebVitals from './reportWebVitals';

import { rootReducer } from './store/reducers';
import { watchGovernorate, watchMarketplace, watchUI } from "./store/sagas";

import './index.css';
import App from './App';
import { registerHandlers } from "./lib/handlers";

console.log(`NODE_ENV ${process.env.NODE_ENV}`);

// eslint-disable-next-line no-underscore-dangle
const composeEnhancer = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const reduxSaga = createSagaMiddleware();

const store = createStore(rootReducer, composeEnhancer(
  applyMiddleware(reduxSaga)
));

reduxSaga.run(watchUI);
reduxSaga.run(watchGovernorate);
reduxSaga.run(watchMarketplace);

registerHandlers(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
